/**
 * The กิจกรรม feed's "ขอเปิดงาน" items (docs/api/SHARING.md). The buttons are a chunk of their own
 * (AccessRequestActions): the app shell only carries this check, and loads them when such an item
 * is actually on screen.
 */
import { lazy, Suspense } from 'react';
import type { ActivityItem } from '../chat/types.js';

/** The request an item is about, while it still waits for an answer. */
export function openAccessRequest(i: ActivityItem): { requestId: string; designId: string; name: string } | null {
  const p = i.payload ?? {};
  if (i.kind !== 'access.requested' || typeof p.accessRequestId !== 'string' || typeof p.designId !== 'string' || p.resolved) return null;
  return { requestId: p.accessRequestId, designId: p.designId, name: typeof p.requesterName === 'string' ? p.requesterName : i.actorName ?? 'สมาชิก' };
}

const Actions = lazy(() => import('./AccessRequestActions.js').then((m) => ({ default: m.AccessRequestActions })));

export function AccessRequestButtons({ item, onDone }: { item: ActivityItem; onDone: (resolved: 'approved' | 'denied' | 'closed') => void }) {
  if (!openAccessRequest(item)) return null;
  return (
    <Suspense fallback={null}>
      <Actions item={item} onDone={onDone} />
    </Suspense>
  );
}
